define('models/trackerTagsEmail',["T1", "T1Model"], function (T1, T1Model) {
  T1.Models.TrackerTagsEmail = T1Model.extend({
    url: "tracker_tags/email"
  });
  return T1.Models.TrackerTagsEmail;
});
